import convertToKebabCase from "@utils/convertToKebabCase"

export default function getJobStatusColorClass(job: Job): string {
    return job.status_color_override ? job.status_color_override : `${convertToKebabCase(job.status_label)}`
}
